import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";

// const API_BASE = `http://${window.location.hostname}:8000`;
const API_BASE = process.env.REACT_APP_API_URL;
// const API_BASE = 'https://spradley-website.onrender.com';
// const MEDIA_BASE = `https://spradley-website-media.s3.amazonaws.com/images`;
const MEDIA_BASE = `${API_BASE}/media`;
const S3_BASE = "https://spradley-website-media.s3.amazonaws.com";
// const CLOUDFRONT_BASE = "https://dya1gu5h2u70i.cloudfront.net"

export function getPDFUrl(mediaId) {
  if (!mediaId) return null;
  const prefix = "pdfs";

  return `${S3_BASE}/${prefix}/${mediaId}`; 
}

export function usePDFUrl(mediaId, options={}) {
  return useQuery({
    queryKey: ["media-url", mediaId],
    enabled: options.enabled ?? !!mediaId,
    queryFn: async () => {
      const res = await fetch(`${MEDIA_BASE}/${mediaId}`);
      if (!res.ok) {
        throw new Error("Failed to fetch media URL");
      }
      return (await res.json()).url;
    },
    staleTime: 50 * 60 * 1000, // 50 minutes
  });
}

export function useUploadPDF() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file) => {
      const authRes = await fetch(`${MEDIA_BASE}/upload`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          filename: file.name,
          content_type: file.type,
        }),
      });
      if (!authRes.ok) {
        const msg = await authRes.json();
        throw new Error(msg.detail || "Failed to authorize upload.");
      }
      const upload = await authRes.json();

      const formData = new FormData();
      Object.entries(upload.fields).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append("file", file);
      
      const s3Res = await fetch(upload.url, {
        method: "POST",
        body: formData,
      });
      if (!s3Res.ok) {
        throw new Error("Failed to upload file to S3.");
      }

      return {
        media_id: upload.media_id,
        original_filename: upload.original_filename,
      };
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["media"],
      });
    },
  });
}

export function useDeletePDF() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (mediaId) => {
      const res = await fetch(`${MEDIA_BASE}/${mediaId}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        const msg = await res.json();
        throw new Error(msg.detail || "Failed to delete media");
      }

      return res.json();
    },

    onSuccess: () => {
      queryClient.invalidateQueries(["media"]);
    },
  });
}
